import '/node_modules/bootstrap/js/src/alert'
import '/node_modules/bootstrap/js/src/button'
import '/node_modules/bootstrap/js/src/collapse'
import '/node_modules/bootstrap/js/src/dropdown'
import '/node_modules/bootstrap/js/src/tab'
import '/node_modules/bootstrap/js/src/tooltip'
